<template>
  <v-dialog
    v-model="open"
    persistent
    max-width="800"
  >
    <v-card color="light" class="pl-5 pr-5 pt-2 pb-2">

      <v-toolbar
        dark
        color="light"
        elevation="0"
      >
        <v-badge
          bordered
          left
          :content="`${cart.cart_products.length}`"
          color="accent"
          offset-x="10"
          offset-y="10"
          class="mt-10"
        >
          <img class="cart-bolsa" src="@/assets/store/iconos/bolsa.svg">
        </v-badge>
        <v-spacer></v-spacer>
        <v-btn
          icon
          @click="open = false"
          color="accent"
          large
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <br><br>
      <v-card-text class="mt-2">

        <div class="text-center color-blue font-general-r">
          <h4>
            RECUERDA: ENTREGAS DE LUNES A DOMINGO DE 12 PM A 6 PM
          </h4>
          <span class="h5">
            *SI REALIZAS TU PEDIDO DESPUÉS DE LAS 6 PM
          </span> <br>
          <span class="h5">
            TU PEDIDO ESTARÁ LLEGANDO AL DÍA SIGUIENTE EN HORARIO HÁBIL.
          </span>
          <br>
        </div>
      </v-card-text>
      <v-card-actions class="mt-2">
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          elevation="0"
          class="nv-btn nv-btn-medium"
          @click="open = false"
        >
          ACEPTAR
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: ["message"],
  data() {
    return {
      open: false
    }
  },
  computed: {
    ...mapState(['cart', 'user', 'is_auth'])
  },
  methods: {
    openDialog() {
      this.open = true;
    },
    close() {
      this.open = false;
    }
  }
}
</script>

<style scoped>
  .img-popup-message {
    width: 150px
  }
</style>
